export default {
  common: {
    ageConfirmed: "21+",
    brandZone: "PARK LIVE • БРЕНД-ЗОНА",
    brandTitle: "ABSOLUT TABASCO",
    brandCollab: "PARK LIVE × ABSOLUT TABASCO",
    close: "Закрыть",
    retry: "Повторить попытку",
    loading: "Загрузка...",
    newParticipant: "Новый участник"
  },
  desktopStub: {
    title: "Доступно только на мобильной версии",
    subtitle: "Пожалуйста, откройте эту страницу со своего смартфона или переключите браузер в режим эмуляции мобильного устройства."
  },
  ageConfirm: {
    title: "Введите дату рождения",
    placeholderDay: "дд",
    placeholderMonth: "мм",
    placeholderYear: "гггг",
    confirmBtn: "Подтверждаю",
    errors: {
      underage: "Для дальнейшего входа нужно достичь 21 года.",
      fillAll: "Пожалуйста, заполните все поля даты",
      invalidDay: "Пожалуйста, введите корректный день (01-31).",
      invalidMonth: "Пожалуйста, введите корректный месяц (01-12).",
      invalidYear: "Пожалуйста, введите корректный год рождения.",
      invalidDate: "Пожалуйста, введите корректную дату."
    }
  },
  otp: {
    title: "введите код",
    description: "На номер был отправлен код, для того чтобы продолжить введите код",
    errorWrongCode: "код введен неверно",
    alreadyRegistered: "Ты уже зарегистрирован",
    resendPrefix: "Повторно отправить SMS можно через {sec} сек.",
    resendBtn: "Повторно отправить SMS",
    confirmBtn: "Подтвердить",
    sendingBtn: "Отправка...",
    successText: "Регистрация пройдена успешно"
  },
  screen1: {
    headerLeft: "PARK LIVE • БРЕНД-ЗОНА",
    subHeader: "PARK LIVE × ABSOLUT TABASCO",
    titleLine1: "ABSOLUT",
    titleLine2: "TABASCO",
    instruction: "ЗАПОЛНИ ФОРМУ, ПРОКРУТИ КОЛЕСО И ЗАБИРАЙ ПРИЗЫ!",
    participateBtn: "УЧАСТВОВАТЬ",
    disclaimer: "НАЖИМАЯ «УЧАСТВОВАТЬ», ВЫ ПОДТВЕРЖДАЕТЕ, ЧТО ВАМ ЕСТЬ 21 ГОД."
  },
  screen2: {
    stepHeaderLeft: "ШАГ 1 ИЗ 2 · РЕГИСТРАЦИЯ",
    stepHeaderRight: "ABSOLUT TABASCO",
    subtitle: "ПОЧТИ ВСЁ",
    heading: "ЗАПОЛНИ ФОРМУ",
    formError: "Ошибка загрузки формы. Попробуйте позже.",
    disclaimer: "Все поля и согласия обязательны для участия.",
    submitBtn: "К КОЛЕСУ ФОРТУНЫ",
    sendingBtn: "ОТПРАВКА...",
    placeholders: {
      fullName: "ФИО",
      name: "Имя",
      surname: "Фамилия",
      city: "Город",
      gender: "Пол",
      email: "Email",
      select: "Выберите вариант",
      login: "Введите логин",
      phone: "+7 (___) ___-__-__"
    },
    gender: {
      label: "Пол",
      male: "Мужской",
      female: "Женский"
    },
    phoneLabel: "Номер телефона",
    consent: {
      personalDataPrefix: "Я даю согласие на",
      personalDataLink: "сбор и обработку персональных данных",
      rulesPrefix: "Я согласен с",
      rulesLink: "правилами участия",
      marketing: "Согласен на использование моих данных в маркетинговых активностях бренда и получение рекламных сообщений."
    },
    errors: {
      required: "Поле обязательно",
      consentRequired: "Вы должны принять условия.",
      lettersOnly: "Допустимы только буквы.",
      invalidEmail: "Введите корректный email.",
      invalidPhone: "Введите корректный номер телефона.",
      fillAllFields: "Пожалуйста, заполните все поля",
      fixErrors: "Исправьте ошибки в форме перед отправкой",
      enterFullName: "Пожалуйста, введите ФИО",
      consentNeeded: "Необходимо принять согласия для участия",
      invalidCode: "Код введён неверно",
      sendCodeError: "Ошибка при отправке кода. Попробуйте снова.",
      botDetected: "Подозрение на бота. Попробуйте перезагрузить страницу."
    }
  },
  screen3: {
    stepHeaderLeft: "ШАГ 2 ИЗ 2 · РОЗЫГРЫШ",
    stepHeaderRight: "ABSOLUT TABASCO",
    title: "КРУТИ КОЛЕСО",
    disclaimer: "ОДИН ЗАХОД НА ОДИН НОМЕР. УДАЧИ.",
    spinBtn: "КРУТИТЬ",
    spinningBtn: "ВРАЩЕНИЕ...",
    badge: "SPIN"
  },
  screen4: {
    stepHeaderLeft: "ТВОЙ РЕЗУЛЬТАТ",
    stepHeaderRight: "ABSOLUT TABASCO",
    physicalInstruction: "Покажи этот экран сотруднику бренд-зоны, чтобы забрать приз.",
    promoHeader: "Промокод на Xo.kz",
    promoInstruction: "Сфотографируй промокод.",
    promoExpiryPrefix: "Воспользуйтесь промокодом",
    promoExpiryUntil: "до {date}.",
    promoExpiryDefaultDate: "30 сентября",
    qrCaption: "Отсканируй QR код для покупки",
    partnerBtn: "ПЕРЕЙТИ НА XO.KZ",
    copyBtn: "Скопировать",
    copiedBtn: "СКОПИРОВАНО!",
    nextParticipantBtn: "СЛЕДУЮЩИЙ УЧАСТНИК",
    nextParticipantSubtitle: "Начать регистрацию следующего участника"
  },
  prizes: {
    fan: {
      name: "Вентилятор",
      sectorText: "ВЕНТИЛЯТОР",
      title: "ПОРТАТИВНЫЙ ВЕНТИЛЯТОР",
      subtitle: "для прохлады в жаркие дни"
    },
    visor: {
      name: "Козырёк",
      sectorText: "КОЗЫРЁК",
      title: "ФИРМЕННЫЙ КОЗЫРЁК",
      subtitle: "стильный фестивальный аксессуар"
    },
    blanket: {
      name: "Плед",
      sectorText: "ПЛЕД",
      title: "УЮТНЫЙ ПЛЕД",
      subtitle: "фирменный брендированный плед"
    },
    bag: {
      name: "Сумка",
      sectorText: "СУМКА",
      title: "ФИРМЕННАЯ СУМКА",
      subtitle: "удобная и стильная сумка"
    },
    promocode: {
      name: "Промокод",
      sectorText: "-20%",
      title: "СКИДКА 20%",
      subtitle: "на покупки на сайте XO.kz"
    },
    defaultPhysicalTitle: "ФИЗИЧЕСКИЙ ПРИЗ"
  },
  legal: {
    policy: {
      title: "Политика конфиденциальности",
      content: `<b>Pernod Ricard Kazakhstan,</b> в качестве оператора персональных данных, уважает ваше право на конфиденциальность при использовании веб-сайта.
Цель настоящей Политики конфиденциальности — информировать вас о том, каким образом компания Pernod Ricard Kazakhstan собирает, хранит, использует и обрабатывает ваши персональные данные, предоставленные через веб-сайт.

<b>1. Какие персональные данные мы собираем?</b>
Мы собираем следующие персональные данные:
 Имя, фамилия
 Дата рождения
 Номер телефона
 Адрес электронной почты
 Город проживания

<b>2. С какой целью мы используем ваши персональные данные?</b>
Pernod Ricard Kazakhstan обрабатывает ваши данные в следующих целях:
 Обеспечение участия в промо-активностях и розыгрышах.
 Проверка соответствия возрастным ограничениям (21+).
 Отправка административных уведомлений и информации о выигрыше.
 При наличии согласия — отправка маркетинговых предложений.

<b>3. Как мы обеспечиваем защиту ваших данных?</b>
Pernod Ricard Kazakhstan принимает все необходимые меры для защиты ваших данных, включая хранение в защищенных средах и ограничение доступа уполномоченными лицами.`
    },
    offer: {
      title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку, распространение и трансграничную передачу моих персональных данных:
1) ФИО
2) Дата рождения
3) Мобильный телефон
4) E-mail
5) Город проживания

<b>Согласованная цель сбора и обработки персональных данных</b> – участие в маркетинговых активностях и розыгрышах призов брендов продукции ТОО «Перно Рикар Казахстан».
Я даю согласие на получение информационных и рекламных сообщений (в том числе SMS и мессенджеры).
Согласие действует в течение срока хранения информации и может быть отозвано по письменному заявлению на адрес promo.kz@pernod-ricard.com.`
    },
    rules: {
      title: "УСЛОВИЯ ПРОВЕДЕНИЯ АКТИВАЦИИ",
      content: `<b>1. Общие положения</b>
1.1. Настоящие Условия определяют порядок проведения активации «Колесо Фортуны Absolut Tabasco».
1.2. Организатор Активации: ТОО «Pernod Ricard Kazakhstan».
1.3. Активация проводится в целях стимулирования потребительского интереса и не является лотереей.

<b>2. Участники Активации</b>
2.1. К участию допускаются дееспособные физические лица, достигшие возраста 21 года на дату участия.
2.2. Один участник может получить не более одного приза в рамках активации.

<b>3. Порядок участия и получения призов</b>
3.1. Для участия необходимо пройти подтверждение возраста, заполнить регистрационную форму, подтвердить номер телефона через OTP и прокрутить Колесо Фортуны.
3.2. Физические призы выдаются на бренд-зоне при предъявлении экрана с результатом.
3.3. Промокоды на скидку могут быть применены на партнерском сайте согласно условиям акции.`
    }
  },
  unsubscribe: {
    title: "Выберите тип коммуникаций, от которого Вы хотели бы отписаться:",
    doNotBulkEmail: "Не получать массовые рекламные и информационные рассылки по E-mail",
    doNotEmail: "Не получать персонифицированные сообщения по E-mail",
    doNotSendMm: "Не получать любые коммуникации по всем каналам связи, включая SMS, телефон и E-mail.",
    submitBtn: "ОТПИСАТЬСЯ",
    savingBtn: "СОХРАНЕНИЕ...",
    successMessage: "Ваши настройки успешно сохранены",
    errorMessage: "Произошла ошибка при сохранении.",
    loadErrorTitle: "Произошла ошибка при загрузке данных",
    loadErrorText: "Не удалось получить ваши настройки. Пожалуйста, попробуйте обновить страницу позже.",
    userNotFound: "Пользователь не найден или ссылка устарела."
  }
};
